
import { Component, Vue } from "vue-property-decorator";
import { modal } from "@/store/modal";
import GoogleMap from "@/components/GoogleMap.vue";

@Component({ components: { GoogleMap } })
export default class ContactInfoModal extends Vue {
  modal: any = modal;
}
